import { gql } from "@apollo/client";

import { Offer as offer } from "../fragments";

const CREATE_CONTACT_LIST_OFFERS = props => gql`
  mutation CreateContactListOffers($input: CreateContactListOffersInput!) {
    createContactListOffers(input: $input) {
      error
      success
      warnings {
        offerId
        message
      }
      created {
        ${offer(props)}
      }
      updated {
        ${offer(props)}
      }
    }
  }
`;

const CREATE_CONTACT_OFFERS = props => gql`
  mutation CreateContactOffers($input: CreateContactOffersInput!) {
    createContactOffers(input: $input) {
      error
      success
      warnings {
        offerId
        message
      }
      created {
        ${offer(props)}
      }
      updated {
        ${offer(props)}
      }
    }
  }
`;

const CREATE_OFFER = props => gql`
  mutation CreateOffer($input: CreateOfferInput!) {
    createOffer(input: $input) {
      error
      offer {
        ${offer(props)}
      }
      success
    }
  }
`;

const CREATE_OFFERS = () => gql`
  mutation CreateOffers($input: CreateOffersInput!) {
    createOffers(input: $input) {
      error
      success
    }
  }
`;

const MOVE_OFFERS = gql`
  mutation MoveOffers($input: MoveOffersInput!) {
    moveOffers(input: $input) {
      error
      success
    }
  }
`;

const REFUSE_OFFERS = gql`
  mutation RefuseOffers($input: RefuseOffersInput!) {
    refuseOffers(input: $input) {
      error
      success
    }
  }
`;

const UPDATE_OFFER = props => gql`
  mutation UpdateOffer($input: UpdateOfferInput!) {
    updateOffer(input: $input) {
      error
      offer {
        ${offer(props)}
      }
      success
    }
  }
`;

export {
  CREATE_CONTACT_LIST_OFFERS,
  CREATE_CONTACT_OFFERS,
  CREATE_OFFER,
  CREATE_OFFERS,
  MOVE_OFFERS,
  REFUSE_OFFERS,
  UPDATE_OFFER,
};
